// extracted by mini-css-extract-plugin
export var table = "_xs-0";